import { getHotelCenterUtils } from '@bingads-webui-campaign/hotel-center-utils';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const pageContext = globalContext.require('PageContext');

export const {
  inlineDownloadUtils,
  dateUtils,
} = getHotelCenterUtils({ pageContext });
